<template>
  <div>
    <global-header :lab_account="lab_account"/>
    <main>
      <div class="uk-section uk-section-small" v-if="loaded">
        <div class="uk-container uk-container-small" v-for="(lab, index) in LABS" :key="lab.lab_no">
          <form class="uk-form-stacked" @submit.prevent="complete_lab(index)">
            <input type="hidden" v-model="lab.lab_no">
            <div class="uk-card uk-card-hover uk-margin-bottom uk-margin-top">
              <div class="uk-card-header">
                <h3 class="uk-card-title">LAB {{lab.lab_no}}: {{lab.title}}<div v-if="lab.complete" class="uk-label uk-margin-left">完了</div></h3>
              </div>
              <div class="uk-card-body">
                <div class="uk-margin" v-if="lab.url_required">
                  <label class="uk-form-label" :for="'form-url-' + index">成果物 URL <span class="uk-label uk-label-danger" v-if="lab.url_required && !lab.complete">必須</span></label>
                  <div class="uk-form-controls">
                    <input class="uk-input" type="text" :id="'form-url-' + index" placeholder="https://..." v-model="lab.url" v-if="!lab.complete">
                    <p v-if="lab.complete"><span class="uk-text-background">{{lab.url}}</span></p>
                  </div>
                </div>
                <div class="uk-margin">
                  <label class="uk-form-label" :for="'form-comment-' + index">コメント（疑問、質問、感じたこと、思ったこと、気がついたこと、など）</label>
                  <div class="uk-form-controls">
                    <textarea class="uk-textarea" v-model="lab.comment" :id="'form-comment-' + index" v-if="!lab.complete"></textarea>
                    <p v-if="lab.complete"><span class="uk-text-background">{{lab.comment}}</span></p>
                  </div>
                </div>
                <div class="uk-margin" v-for="(q, i) in lab.knowledge_test" :key="q.no">
                  <label class="uk-form-label" :for="'form-knowledge-test-' + i">【知識の確認】{{q.question}}</label>
                  <div class="uk-form-controls">
                    <textarea class="uk-textarea" :id="'form-knowledge-test-' + i" v-model="q.answer" v-if="!lab.complete"></textarea>
                    <p v-if="lab.complete"><span class="uk-text-background">{{q.answer}}</span></p>
                  </div>
                </div>
              </div>
              <div class="uk-card-footer">
                <button class="uk-button uk-button-primary" type="submit" v-if="!lab.complete">ラボ完了</button>
              </div>
            </div>
          </form>

          <hr class="uk-divider-icon">

        </div>
      </div>
      <div class="uk-section uk-section-small" v-if="!loaded">
        <div class="uk-position-center" uk-spinner="ratio: 3"></div>
      </div>
    </main>
  </div>
</template>

<script>

import GlobalHeader from "./Header"
import axios from 'axios'
import constants from '../mixins/constants'

export default {
  name: 'Home',
  components: {
    GlobalHeader
  },
  mixins: [constants],
  data: function() {
    return {
      lab_account: "",
      loaded: false
    };
  },
  mounted() {
    var $this = this;
    var lab_account = localStorage.lab_account;
    var curr_course = localStorage.course;

    if (!lab_account || lab_account && curr_course !== this.COURSE) {
        localStorage.lab_account = '';
        localStorage.course = ''
        this.$router.push('/')
    }

    $this.lab_account = lab_account;
    axios.get($this.APIGW_ENDPOINT + "/" + lab_account)
    .then(function(response) {
      if ( response.data.Count ) {
        $this.LABS.forEach(function(v,i) {
          var data = response.data.Items.find((d) => {
            return (v.lab_no === d.lab_no)
          });
          if (data) {
            $this.LABS[i].complete = 1;
            if ("url" in data)
              $this.LABS[i].url = data.url;
            if("comment" in data)
              $this.LABS[i].comment = data.comment;
            var knowledge_test = data.knowledge_test;
            if (knowledge_test) {
              knowledge_test.forEach(function(q,j) {
                $this.LABS[i].knowledge_test[j].answer = q.answer;
              });
            }
          }
        })
      }
      $this.loaded = true;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    complete_lab: function(i) {
      var data = {
        lab_account: this.lab_account,
        lab_no: this.LABS[i].lab_no,
      }

      if ( this.LABS[i].url )
        data.url = this.LABS[i].url;

      if ( this.LABS[i].comment )
        data.comment = this.LABS[i].comment;
      if( this.LABS[i].knowledge_test )
        data.knowledge_test = this.LABS[i].knowledge_test;

      var now = new Date();
      data.date = now.getFullYear()
        + "-"
        + ("00" + (now.getMonth() + 1)).slice(-2)
        + "-"
        + ("00" + (now.getDate() + 1)).slice(-2);
      data.time = ("00" + (now.getHours() + 1)).slice(-2)
        + ":"
        + ("00" + (now.getMinutes() + 1)).slice(-2)
        + ":"
        + ("00" + (now.getSeconds() + 1)).slice(-2)

      var $this = this;
      axios.post($this.APIGW_ENDPOINT, data)
        .then(function (response) {
          if (response.status == 200) {
            $this.LABS[i].complete = 1;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>
